import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import { getImage } from '@utils/imageHelper';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px;
  text-align: center;
  background-color: var(--color-base-1);
  margin: auto;
  margin-top: 50px;

  ${mediaQuery.uptoMobile} {
    padding: 20px 16px;
    margin-top: 0;
  }
`;

const Image = styled.img`
  height: 135px;
  margin-bottom: 20px;

  ${mediaQuery.uptoMobile} {
    height: 100px;
  }
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.5%;
  text-align: center;
  color: var(--color-base-fill);
  margin-bottom: 12px;

  ${mediaQuery.uptoMobile} {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
`;

const Description = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: var(--color-text-secondary);

  ${mediaQuery.uptoMobile} {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
  }
`;

const InfoCard = styled.div`
  background-color: var(--color-base-light-0);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 10px;
  width: 100%;
  max-width: 500px;
  text-align: left;

  ${mediaQuery.uptoMobile} {
    padding: 20px;
    margin-bottom: 30px;
  }
`;

const InfoLabel = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--color-text-secondary);
  margin-bottom: 8px;
  margin-top: 3px;

  ${mediaQuery.uptoMobile} {
    font-size: 12px;
    line-height: 16px;
  }
`;

const InfoValue = styled.p`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--color-text-primary);
  word-break: break-all;

  ${mediaQuery.uptoMobile} {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 16px;
  }
`;
interface EventsHomeProps {
  youtubeId?: string;
  email?: string;
}

const EventsHome = ({ youtubeId, email }: EventsHomeProps) => {
  const hasEmail = email && email.trim() !== '';

  return (
    <Container>
      <Image src={getImage('youtube_id_submitted.svg')} alt="submitted" />
      <Title>Linked Channel Details</Title>
      {youtubeId && (
        <InfoCard>
          {hasEmail && (
            <>
              <InfoLabel>Email</InfoLabel>
              <InfoValue>{email}</InfoValue>
            </>
          )}
          <InfoLabel>YT Channel ID</InfoLabel>
          <InfoValue>{youtubeId}</InfoValue>
        </InfoCard>
      )}
      <Description>
        Please return to YouTube to participate in polls.
      </Description>
    </Container>
  );
};

export default EventsHome;
